module.exports = __webpack_public_path__ + "images/homepage-step1.svg";


//////////////////
// WEBPACK FOOTER
// ./_common/images/homepage-step1.svg
// module id = 159
// module chunks = 1